import {utils} from '@wallaby-ui/core';

import styles from 'src/js/common/components/formatters/ProgressFormatter.less';
import baseProgressFormatterParams from 'src/js/lib/raw_rendering/base_progress_formatter_params';

/**
 * Returns raw Html version of ProgressFormatter component.
 * @param params
 * @param services
 * @returns {String}
 */
export default function progressFormatter(params, services = {}) {
  const {progressValue, formattedValue, label, backgroundColor, fontStyle} =
    baseProgressFormatterParams(params, services);

  const decimalValue = utils.NumberUtils.roundToWantedDecimals(
    progressValue * 100,
    2
  );

  return `<div
            class="${styles.dlProgressFormatter}"
            style="background-color: ${backgroundColor};
                   width: ${decimalValue}%;"

        >
            <div class="${styles.dlProgressFormatterValue}"
                 title="${label}"
                 style="font-family: ${fontStyle}"
            >
                ${formattedValue}
            </div>
        </div>
        `;
}
